function init() {
    const header = document.querySelector('.js-header');
    if (header) {
        function change() {
            if (window.scrollbar.scrollTop > 200) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        }
        change();
        window.scrollbar.addListener(change);
    }
}

export default { init };
